import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AppEn from "./AppEn";

// Get language from URL path
const currentPath = window.location.pathname;
const isEnglish = currentPath.startsWith('/en');

// Set language for other components
window.appLanguage = isEnglish ? 'en' : 'tr';

// Choose which App component to render based on language
const RootApp = isEnglish ? AppEn : App;

ReactDOM.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>,
  document.getElementById("root"),
);